(function ($) {

    var articleImages = $('.page-base__main__body').find('img');

    articleImages.each(function (i, ele) {

        var img = $(ele);
        var title = img.attr('title');

        if (title !== undefined) {
            var wrapper = img.wrap('<figure class="image-caption-wrapper"></figure>').parent();

            if (img.css('float')) {
                var float = img.css('float');
                wrapper.css('float', float);

                // Apply correct margin to figure element when floated
                if (float === 'right') {
                    wrapper.css('margin-left', '22px');
                } else if (float === 'left') {
                    wrapper.css('margin-right', '22px');
                }
                img.css('padding', 0);
            }

            img.after('<figcaption class="image-text">' + title + '</figcaption>');
        }
    });

})(jQuery);
